import { Config } from "../../interfaces";
import { results } from "./results";
import { ui } from "./ui";
import { appState } from "./appState";
import { combineReducers } from "redux";
import { hist } from "../services/BrowserLocation";
import { connectRouter } from "connected-react-router";
import { routerHistory } from "./routerHistory";

export const initialConfigState: Config = {
  docsPath: "docs/summary_properties.yaml",
  apiPath: "/api/institutions",
};

export function passThrough(
  state: Config = initialConfigState,
  action: any,
): Config {
  return state;
}

const rootReducer: any = combineReducers<any>({
  results,
  ui,
  appState,
  config: passThrough,
  routerHistory,
  router: connectRouter(hist),
});

export default rootReducer;
